import { useRef, useState } from "react";
import { Download, FileSpreadsheet, Plus, Upload } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useImportJob } from "@/hooks/useImportJob";
import { ImportProgress, ResumoImportacao } from "@/components/ImportProgress";

export function CadastroProdutosCard({ ultima, onDone, onCadastrar }) {
  const inputRef = useRef(null);
  const [resumo, setResumo] = useState(null);
  const { job, start, running } = useImportJob((resultado) => {
    setResumo(resultado);
    onDone?.(resultado);
  });

  const exportar = async () => {
    try {
      const response = await api.get("/produtos/export/cadastro.csv", {
        responseType: "blob",
      });
      const url = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = "cadastro_produtos.csv";
      link.click();
      URL.revokeObjectURL(url);
      toast.success("Cadastro de produtos exportado");
    } catch {
      toast.error("Não foi possível exportar o cadastro");
    }
  };

  return (
    <div
      className="border border-[#B9D9C7] bg-[#F6FBF7] p-4 shadow-sm rounded-lg"
      data-testid="cadastro-produtos-card"
    >
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#EAF7EF]">
          <FileSpreadsheet className="h-5 w-5 text-[#0F6B3A]" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-bold text-[#0F2A1F]">Cadastro de Produtos</div>
          <div className="mt-0.5 text-xs text-[#5A6B62]">
            Código, descrição, EAN e unidades por caixa fechada
          </div>
        </div>
      </div>

      <input
        ref={inputRef}
        type="file"
        accept=".xlsx,.csv"
        className="hidden"
        data-testid="cadastro-produtos-import-input"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) start("/estoque/import/cadastro", file);
          event.target.value = "";
        }}
      />

      <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-3">
        <button
          data-testid="cadastro-produtos-import-btn"
          disabled={running}
          onClick={() => inputRef.current?.click()}
          className="flex items-center justify-center gap-2 rounded-md bg-[#0F6B3A] px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#0B5530] disabled:opacity-60"
        >
          <Upload className="h-4 w-4" />
          Importar CSV/XLSX
        </button>
        <button
          data-testid="cadastro-produtos-export-btn"
          onClick={exportar}
          className="flex items-center justify-center gap-2 rounded-md border border-[#0F6B3A] bg-white px-3 py-2 text-sm font-semibold text-[#0F6B3A] transition-colors hover:bg-[#EAF7EF]"
        >
          <Download className="h-4 w-4" />
          Exportar CSV
        </button>
        <button
          data-testid="cadastro-produtos-novo-btn"
          onClick={onCadastrar}
          className="flex items-center justify-center gap-2 rounded-md border border-[#B9D9C7] bg-white px-3 py-2 text-sm font-semibold text-[#0F2A1F] transition-colors hover:bg-[#EAF7EF]"
        >
          <Plus className="h-4 w-4" />
          Cadastrar produto
        </button>
      </div>

      <ImportProgress job={job} testid="cadastro-produtos-import-progress" />
      {resumo ? (
        <ResumoImportacao r={resumo} testid="cadastro-produtos-import-resumo" />
      ) : ultima ? (
        <div
          className="mt-3 font-mono text-[11px] text-[#8A9A90]"
          data-testid="cadastro-produtos-import-ultima"
        >
          Última: {ultima.novo?.arquivo} · {ultima.usuario} · {ultima.novo?.incluidos} incluídos
        </div>
      ) : null}
    </div>
  );
}